import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A1628] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-16 pb-8">
        {/* Top Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="bg-white rounded-xl px-3 py-1.5 inline-block mb-4">
              <img
                src="https://static.readdy.ai/image/dfc6db26b98ba2c0b04cea29bf715fac/ef60e386036071c16748ee6a2c11d513.png"
                alt="Printven LLC"
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Personalización profesional con más de 30 años de experiencia en impresión DTF, sublimación y soluciones comerciales.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              <a href="#navegacion" id="navegacion">Navegación</a>
            </h4>
            <ul className="flex flex-col gap-2">
              {[
                { label: 'Inicio', path: '/' },
                { label: 'Servicios', path: '/servicios' },
                { label: 'Productos', path: '/productos' },
                { label: 'Sobre Nosotros', path: '/nosotros' },
                { label: 'Contacto', path: '/contacto' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/60 text-sm hover:text-[#FF6B35] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              <a href="#servicios-footer" id="servicios-footer">Servicios</a>
            </h4>
            <ul className="flex flex-col gap-2">
              {[
                'Impresión DTF',
                'Sublimación',
                'Impresión Comercial',
                'Microperforados',
              ].map((s) => (
                <li key={s}>
                  <Link
                    to="/servicios"
                    className="text-white/60 text-sm hover:text-[#FF6B35] transition-colors cursor-pointer"
                  >
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              <a href="#contacto-footer" id="contacto-footer">Contacto</a>
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-[#FF6B35] text-base"></i>
                </div>
                <a href="tel:+17542034748" className="text-white/60 text-sm hover:text-white transition-colors">
                  +1 754-203-4748
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-[#FF6B35] text-base"></i>
                </div>
                <span className="text-white/60 text-sm">Indianapolis, IN 46224</span>
              </li>
              <li className="mt-2">
                <a
                  href="https://wa.me/17542034748"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-2 bg-[#25D366] text-white text-sm font-semibold px-4 py-2 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#1ebe5a] transition-colors"
                >
                  <i className="ri-whatsapp-line text-base"></i>
                  Chatea con nosotros
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-sm">
            © {currentYear} Printven LLC. Todos los derechos reservados.
          </p>
          <p className="text-white/30 text-xs">
            Indianapolis, IN 46224 · +1 754-203-4748
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
